// src/redux/api/attendance.js
import { apiSlice } from ".";
import { toast } from "react-toastify";

export const attendanceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postAttendance: builder.mutation({
      query: (payload) => ({
        url: "Attendance/PostAttendance",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Attendance"], // invalidate cache
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Attendance submitted successfully!");
        } catch {
          toast.error("Failed to submit attendance.");
        }
      },
    }),

    getAttendanceByDateRange: builder.query({
      query: ({ fromDate, toDate, agencyId, agentId }) =>
        `Attendance/GetAttendanceByDateRange?fromDate=${fromDate}&toDate=${toDate}&agencyId=${agencyId}&agentId=${agentId}`,
      providesTags: ["Attendance"], // provide cache tag
    }),

    deleteAttendance: builder.mutation({
      query: (id) => ({
        url: `Attendance/DeleteAttendance/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Attendance"], // refresh attendance list
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Attendance record deleted!");
        } catch {
          toast.error("Failed to delete attendance.");
        }
      },
    }),

    putAttendance: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `Attendance/PutAttendance/${id}`,
        method: "POST", // backend expects POST for update
        body: payload,
      }),
      invalidatesTags: ["Attendance"], // refresh attendance list
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Attendance updated successfully!");
        } catch {
          toast.error("Failed to update attendance.");
        }
      },
    }),
  }),
});

export const {
  usePostAttendanceMutation,
  useGetAttendanceByDateRangeQuery,
  useLazyGetAttendanceByDateRangeQuery,
  useDeleteAttendanceMutation,
  usePutAttendanceMutation,
} = attendanceApi;
